import React from 'react'

import { ReactComponent as Canais } from '../../assets/svgs/procedures/canais.svg';
import { ReactComponent as Clareamento } from '../../assets/svgs/procedures/clareamento.svg';
import { ReactComponent as Infantil } from '../../assets/svgs/procedures/infantil.svg';
import { ReactComponent as Limpeza } from '../../assets/svgs/procedures/limpeza.svg';
import { ReactComponent as Ortodontia } from '../../assets/svgs/procedures/ortodontia.svg';
import { ReactComponent as RaioX } from '../../assets/svgs/procedures/raiox.svg';
import { ReactComponent as Restauracao } from '../../assets/svgs/procedures/restauracao.svg';
import { ReactComponent as UrgenciaEmergencia } from '../../assets/svgs/procedures/urgencia-emergencia.svg';
import { ReactComponent as ClinicaGeral } from '../../assets/svgs/procedures/clinica-geral.svg';
import { ReactComponent as CirurgiaOral } from '../../assets/svgs/procedures/cirurgia-oral.svg';
import { ReactComponent as Gengivas } from '../../assets/svgs/procedures/gengivas.svg';
import { ReactComponent as Protese } from '../../assets/svgs/procedures/protese.svg';

export const DENTAL_SERVICES = [
  { name: 'Restauração', icon: Restauracao },
  { name: 'Tratamento Infantil', caption: '(Odontopediatria)', icon: Infantil },
  { name: 'Canais', icon: Canais },
  { name: 'Limpeza', icon: Limpeza },
  { name: 'Raio X', caption: '(Radiologia)', icon: RaioX }
]

export const MAIN_DENTAL_SERVICES_PJ = [
  { name: 'Urgência e Emergência', icon: UrgenciaEmergencia },
  { name: 'Clínica Geral', icon: ClinicaGeral },
  { name: 'Cirurgia Oral Menor', icon: CirurgiaOral },
  { name: 'Tratamento de Gengivas', icon: Gengivas },
  { name: 'Próteses', caption: '(RN 211/2010)', icon: Protese },
  ...DENTAL_SERVICES,
]

export const MAIN_DENTAL_SERVICES_PF = [ 
  { name: 'Aparelhos Ortodônticos', caption: '(RN 211/2010)', icon: Ortodontia },
  ...MAIN_DENTAL_SERVICES_PJ
]

export const fullOrthodontic = { name: 'Ortodontia Completa', icon: Ortodontia };